import React, { useEffect, useState } from 'react';
import { Card } from '@heroui/react' // Assurez-vous d'avoir installé et configuré ReactUI
import { TrendingUp } from 'lucide-react'; // Vous pouvez choisir une autre icône de Lucide si besoin
import { motion, AnimatePresence } from 'framer-motion';

const AnimatedCounter = ({ target = 100, title = "Counter", Icon = TrendingUp }) => {
    const [count, setCount] = useState(0);
    const [showFallAnimation, setShowFallAnimation] = useState(true);

    // Animation de comptage de 0 au nombre cible sur 2 secondes
    useEffect(() => {
        const duration = 2000; // durée totale de l'animation (ms)
        const intervalTime = 50; // intervalle de mise à jour (ms)
        const steps = duration / intervalTime;
        const increment = target / steps;
        let current = 0;
        const interval = setInterval(() => {
            current += increment;
            if (current >= target) {
                setCount(target);
                clearInterval(interval);
            } else {
                setCount(Math.floor(current));
            }
        }, intervalTime);
        return () => clearInterval(interval);
    }, [target]);

    // L'effet de "chute" sera visible pendant 1 seconde, puis disparaît
    useEffect(() => {
        const timer = setTimeout(() => {
            setShowFallAnimation(false);
        }, 1000);
        return () => clearTimeout(timer);
    }, []);

    // Variantes pour l'animation de chute : apparait depuis le haut, se stabilise puis descend et disparaît
    const fallVariants = {
        initial: { y: -50, opacity: 0 },
        animate: { y: 0, opacity: 1 },
        exit: { y: 50, opacity: 0 }
    };

    return (
        <motion.div
            initial={{ opacity: 0, scale: 0.8 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ duration: 0.5 }}
        >
            <Card shadow="sm" className="w-full p-6 bg-white rounded-lg flex flex-col items-center dark:bg-primary">
                {/* Titre et icône */}
                <div className="flex items-center space-x-3">
                    <Icon className="w-6 h-6 text-primary dark:text-gray-100" />
                    <h2 className="text-lg font-bold dark:text-gray-100">{title}</h2>
                </div>
                {/* Compteur animé */}
                <div className="mt-4 text-5xl font-bold text-gray-800 relative dark:text-gray-100">
                    {count}
                    {/* Animation de chute : le nombre tombe sur le composant puis disparaît */}
                    <AnimatePresence>
                        {showFallAnimation && (
                            <motion.span
                                key="falling"
                                className="absolute inset-0 flex items-center justify-center text-5xl font-bold text-primary text-opacity-30 dark:text-gray-300"
                                variants={fallVariants}
                                initial="initial"
                                animate="animate"
                                exit="exit"
                                transition={{ duration: 1 }}
                            >
                                {count}
                            </motion.span>
                        )}
                    </AnimatePresence>
                </div>
            </Card>
        </motion.div>
    );
};

export default AnimatedCounter;
